import { useQuery, queryOptions } from '@tanstack/react-query';
import { apiClient } from '../client';
import { organizationKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import { showOrgSettingsContract, type ShowOrgSettingsResponse } from '@bliks-io/contracts';

export const orgSettingsQueryOptions = queryOptions({
  queryKey: organizationKeys.settings(),
  queryFn: async ({ signal }): Promise<ShowOrgSettingsResponse['data']> => {
    const { data } = await apiClient.get<ShowOrgSettingsResponse>(showOrgSettingsContract.path, {
      signal
    });
    return data.data;
  }
});

export function useOrgSettings() {
  const { token, isSuperAdmin } = useAuthStore();

  return useQuery({
    ...orgSettingsQueryOptions,
    // Staff sessions run against the SuperAdmin DB, which holds no organization.
    enabled: !!token && !isSuperAdmin(),
    staleTime: 5 * 60 * 1000
  });
}
